export const DEFAULT_APP_LOCALE = 'de';
